import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import React, { useState } from 'react';
import Slider from 'react-slick';

import type { LoanSchemeType } from '@/api/avail-loan';
import { useLiveGoldPrice, useLoanScheme } from '@/api/avail-loan';
import { formatToCurrency } from '@/utils';
import { schemaConfig } from '@/utils/constants/carousel/schema-settings';

import { LoanSchemes } from '../LoanSchemes/LoanSchemes';

const AtrractiveSchemes = () => {
  const { liveGoldPrice } = useLiveGoldPrice();
  const { loanSchemes } = useLoanScheme();
  const [modal, setModal] = useState(false);
  const [loanScheme, setLoanScheme] = useState<LoanSchemeType>();
  const handleSchemeSelect = (scheme: LoanSchemeType) => {
    setLoanScheme(scheme);
    setModal(true);
  };

  const colorClasses = ['mfone-green', 'mfone-blue', 'mfone-yellow'];

  return (
    <>
      <section className="bg bg--ultraLight home__scheme mfone-landing-schemes mfone-attractive-schemes pb-2 pt-4">
        <div className="container">
          <h2 className="section__title-small text--bold text--black text-center">
            {/* We Offer the
            <span className="text--yellow"> Most Attractive Schemes</span> for
            your Loan */}
            Gold Loan Plans Customers Prefer The Most
          </h2>
          <p className="section__desc text--gray text-center">
            {/* Trust is a key component to the way we treat our customers */}
            Choose a plan to cover your finances
          </p>
        </div>
        <div className="home-scheme-slider blog-cards-container home-scheme-margin">
          <Slider {...schemaConfig} className="test-carousel2 test-carousel3">
            {loanSchemes.map((eachSchme, index) => (
              <div className="item mfone-scheme-card " key={index}>
                {eachSchme.ranges.slice(0, 1).map((range) => (
                  <div
                    key={range.id}
                    className={`scheme__card scheme-info-tag-parent  ${
                      colorClasses[index % 3] || ''
                    }`}
                  >
                    <p className="text--semi mfone-text-primary label">
                      Interest Rate{' '}
                    </p>
                    <p className="text--bold mfone-text-primary title">
                      {range.rateOfInterest}% p.a.
                    </p>
                    <p className="text--semi mfone-text-primary desc">
                      <span className="mfone-text-primary text--regular text--italic">
                        {(range.rateOfInterest / 12).toFixed(2)}% p.m.{' '}
                      </span>
                      at ₹{(liveGoldPrice * (eachSchme.ltv / 100)).toFixed(2)}
                      /gm
                    </p>
                    <ul>
                      <li className="text--semi mfone-text-primary">
                        {eachSchme.loanTenure} months tenure
                      </li>
                      <li className="text--semi mfone-text-primary">
                        {eachSchme.loanStartingValue === '0'
                          ? 'All loan amounts'
                          : `${formatToCurrency(
                              eachSchme.loanStartingValue
                            )} to ${formatToCurrency(
                              eachSchme.loanEndingValue
                            )}`}
                      </li>
                    </ul>
                    <a
                      href=""
                      data-toggle="modal"
                      data-target="#loanDetail"
                      className="custom__arrowButton text--semi"
                      onClick={(e) => {
                        e.preventDefault();
                        handleSchemeSelect(eachSchme);
                      }}
                    >
                      Know more
                    </a>
                    <div className="scheme-info-tag">
                      <p>*Available only in select cities</p>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </Slider>
        </div>
        <button
          className="position-relative custom__button custom__link--dark border-btn text--bold m-auto w-10"
          onClick={() => {
            window.open('https://www.muthootfincorp.com/gold-loan/', '_blank');
          }}
        >
          View All Schemes
        </button>
        {modal && loanScheme && <LoanSchemes loanScheme={loanScheme} />}
      </section>
    </>
  );
};

export default AtrractiveSchemes;
